import { addFolder } from '../../actions/folders/actions';
import { notify } from '../../actions/notifications';
import { setShareModal } from '../../actions/shareCollection';
import { initialShareCollectionValue } from '../../reducers/shareCollection/utils';
import { fetchWebCreateFolder, TWebCreateFolderResponse } from '../../repositories/favorites/v1/web-create-folder';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export interface ICreateFolderRequest {
  name: string;
}

export const createFolder =
  (name: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const parameters: ICreateFolderRequest = {
      name,
    };

    const showError = () => dispatch(notify('Не удалось создать подборку', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebCreateFolderResponse = await fetchWebCreateFolder({ httpApi, parameters });

      if (statusCode === 200) {
        dispatch(addFolder({ id: response.id, name: response.name }));
        dispatch(setShareModal({ id: response.id, ...initialShareCollectionValue, name }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message);
      }
    } catch (e) {
      showError();
      logger.error(e, {
        description: 'Fail to create favorites folder',
      });
    }
  };
